import setFieldValue from "@iewcasia/Store/Handlers/InstantRegistrationForm/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    OwnProps,
    setInstantFormEffects,
    setRequestFormEffects,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    instantRegEmail: state.customInstantRegistrationForm.fieldValues.instantRegEmail,
    confirmInstantRegEmail: state.customInstantRegistrationForm.fieldValues.confirmInstantRegEmail,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const confirmInstantRegEmailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const ConfirmInstantRegEmail: React.FC<Props> = ({confirmInstantRegEmail, instantRegEmail, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Instant Confirm Email Address");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validateEmail = () => {
        let errorMessage: any = "";
        if (!confirmInstantRegEmail && isRequired) {
            errorMessage = siteMessage("Field_Required", label);
        } else if (confirmInstantRegEmail && !confirmInstantRegEmailRegexp.test(confirmInstantRegEmail)) {
            errorMessage = siteMessage("ContactUsForm_EmailIsInvalidErrorMessage");
        } else if (confirmInstantRegEmail && confirmInstantRegEmail !== instantRegEmail) {
            errorMessage = translate("Emails don't match");
        }

        setFieldErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    setInstantFormEffects(isRequired, confirmInstantRegEmail, "confirmInstantRegEmail", validateEmail);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "confirmInstantRegEmail", value: event.target.value });
    };

    const fieldBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        validateEmail();
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={confirmInstantRegEmail || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            onBlur={fieldBlurHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmInstantRegEmail);
